const pillarNameRegEx = /^\.\/([\w\d]+Pillar)\/loader\.(ts|tsx)$/;

// the filter expression must be exactly the same as pillarNameRegEx variable
// cannot use the variable because `require.context` is not a method, but a static WebPack expression
const req = require.context("..", true, /^\.\/([\w\d]+Pillar)\/loader\.(ts|tsx)$/);

// import all pillar loaders
const pillars = (): Record<string, <T>(props: T) => JSX.Element> =>
  req.keys().reduce((acc, fileName: string) => {
    const key = pillarNameRegEx.exec(fileName)?.[1];

    return key
      ? {
          ...acc,
          [key]: req(fileName).default,
        }
      : acc;
  }, {});

export default pillars();
